import React from 'react'
import styles from "./index.module.less";
import { PhoneFilled, EnvironmentFilled } from '@ant-design/icons'
export default function Footer() {
  return (
    <footer>
      {/* <p className={styles.contact}>联系我们</p> */}
      <div className={styles.info}>
        <div className={styles.logo}>
          <img src="https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/huiyu_logoblue.png" alt="logo" />
          <span>会/誉/会/展</span>
        </div>
        <div className={styles.phone}>
          <PhoneFilled className={styles.phone_ico} />
          <div>
            <span>服务电话：+86 21 6125 8698</span>
            <span>邮&nbsp;&nbsp;箱：mkt@huiyuexpo.com</span>
          </div>
        </div>
        {/* <div className={styles.phone}>
          <EnvironmentFilled className={styles.phone_ico} />
          <div>
            <span>地址：上海市普陀区中江路388
              国盛中心1号楼1901-1902</span>
          </div>
        </div> */}
        <div className={styles.wx}>
          <img src="https://hyhzgw-1316759422.cos.ap-shanghai.myqcloud.com/assets/gsErWei.jpg" alt="wx" />
          <div>官方微信</div>
        </div>
      </div>
      {/* <hr /> */}
      <div style={{ display: 'flex' }}>
        <div className={styles.beian} style={{width:'100%'}}>
          <span>© 2025 HUIYU EXHIBITION (SHANGHAI) CO.,LTD.会誉会展（上海）有限公司</span>
          <a rel="noreferrer" target='_blank' href='https://beian.miit.gov.cn/'>沪ICP备 2020038301号-1</a>
          <a rel="noreferrer" target='_blank' href='https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010702006865'>沪公网安备 31010702006865号</a>
        </div>
        {/* <div className={styles.beian}>
          <span>赞助商与参会代表 Echo Guo +86-21-61258698 echo.guo@huiyuexpo.com</span>
          <span>分享嘉宾与免费席位 Steven Zhou +86-21-61155897 Steven.zhu@huiyuexpo.com</span>
        </div> */}
      </div>
    </footer>
  )
}
